var map = {
	"./3.png": "./src/images/Lohas/3.png",
	"./bedroom.png": "./src/images/Lohas/bedroom.png",
	"./bedroom2.png": "./src/images/Lohas/bedroom2.png",
	"./kitchen.png": "./src/images/Lohas/kitchen.png",
	"./kitchen2.png": "./src/images/Lohas/kitchen2.png",
	"./livingroom.png": "./src/images/Lohas/livingroom.png",
	"./livingroom2.png": "./src/images/Lohas/livingroom2.png",
	"./wardrobe.png": "./src/images/Lohas/wardrobe.png",
	"./wardrobedesk.png": "./src/images/Lohas/wardrobedesk.png",
	"./wc.png": "./src/images/Lohas/wc.png",
	"./wc2.png": "./src/images/Lohas/wc2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images/Lohas sync recursive \\.(png%7Cjpe?g%7Csvg)$";